import React from 'react';
import PropTypes from 'prop-types';

const Product = ({
  image,
  name,
  description,
  customizeCampaign,
}) => (
  <>
    <div className="select-imgs">
      <div className="select-item item-2">
        <img
          src={image}
          alt="product"
        />
      </div>
    </div>
    <div className="desc-2">
      <span className="select-text__sm">{customizeCampaign}</span>
      <p className="select-item-desc">
        <b>{name}</b>
        <br />
        {description}
      </p>
    </div>
  </>
);

Product.defaultProps = {
  image: '',
  name: '',
  description: '',
  customizeCampaign: '',
};

Product.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  customizeCampaign: PropTypes.string,
};

export default Product;
